/**
 * Resolve uma URL de imagem, convertendo links do Google Drive para
 * URLs diretas de imagem embeddable.
 *
 * Formatos suportados de entrada:
 *  - https://drive.google.com/file/d/FILE_ID/view?usp=sharing
 *  - https://drive.google.com/file/d/FILE_ID/view
 *  - https://drive.google.com/open?id=FILE_ID
 *  - https://drive.google.com/uc?export=view&id=FILE_ID
 *  - https://drive.google.com/uc?id=FILE_ID
 *
 * Saída: https://lh3.googleusercontent.com/d/FILE_ID
 * (requer que o arquivo esteja compartilhado como "Qualquer pessoa com o link")
 */
export function resolveImageUrl(url) {
    if (!url || typeof url !== "string") return url;

    const trimmed = url.trim();
    if (!trimmed) return trimmed;

    // Já é URL direta do CDN do Google — não precisa converter
    if (trimmed.includes("lh3.googleusercontent.com")) return trimmed;

    // Só processa URLs do Google Drive
    if (!trimmed.includes("drive.google.com")) return trimmed;

    let fileId = null;

    // Padrão: /file/d/FILE_ID/  ou  /file/d/FILE_ID?
    const fileMatch = trimmed.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
    if (fileMatch) {
        fileId = fileMatch[1];
    }

    // Padrão: ?id=FILE_ID ou &id=FILE_ID
    if (!fileId) {
        const idMatch = trimmed.match(/[?&]id=([a-zA-Z0-9_-]+)/);
        if (idMatch) {
            fileId = idMatch[1];
        }
    }

    if (fileId) {
        return `https://lh3.googleusercontent.com/d/${fileId}`;
    }

    // Não reconhecido — retorna original
    return trimmed;
}

/**
 * Detecta se uma URL é do Google Drive.
 */
export function isDriveUrl(url) {
    return typeof url === "string" && url.includes("drive.google.com");
}

/**
 * Detecta se uma URL já foi convertida para lh3 (origin de uma conversão Drive).
 */
export function isResolvedDriveUrl(url) {
    return typeof url === "string" && url.includes("lh3.googleusercontent.com");
}

/**
 * Retorna true se a URL é um link do Drive OU já foi convertida.
 */
export function isFromDrive(url) {
    return isDriveUrl(url) || isResolvedDriveUrl(url);
}
